module.exports = __webpack_public_path__ + "img/communication-banner-catalogue.6f5eed17.svg";